export const fontSizes: Record<string, string> = {
  xs: "12px", sm: "14px", base: "16px", lg: "18px",
  xl: "20px", "2xl": "24px", "3xl": "30px", "4xl": "36px",
};

export const fontWeights: Record<string, string> = {
  thin: "100", extralight: "200", light: "300", normal: "400",
  medium: "500", semibold: "600", bold: "700", extrabold: "800", black: "900",
};

export const lineHeights: Record<string, string> = {
  none: "1", tight: "1.25", snug: "1.375", normal: "1.5",
  relaxed: "1.625", loose: "2",
  "3": "12px", "4": "16px", "5": "20px", "6": "24px",
  "7": "28px", "8": "32px", "9": "36px", "10": "40px",
};

export const letterSpacings: Record<string, string> = {
  tighter: "-0.05em", tight: "-0.025em", normal: "0em",
  wide: "0.025em", wider: "0.05em", widest: "0.1em",
};

export const fontFamilies: Record<string, string> = {
  sans: "ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  serif: "ui-serif, Georgia, Cambria, 'Times New Roman', Times, serif",
  mono: "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Courier New', monospace",
};